import { faCheckCircle, faChevronCircleLeft, faChevronCircleRight, faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AuthContext from "context/AuthContext";
import { Button } from "flowbite-react";
import AddWallet from "Pages/Dashboard/AddWallet/AddWallet";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";
import BottomSheet from "./reusable/BottomSheet";

function ScrollableWalletsDesktop({ sideBar = false }) {
  const { user, wallets, getProfile, storeTokens } = useContext(AuthContext);

  const [showWalletLeft, setShowWalletLeft] = useState(false);
  const [showWalletRight, setShowWalletRight] = useState(false);

  const [showSwitchWallet, setShowSwitchWallet] = useState(false);
  const [switchWalletContextId, setSwitchWalletContextId] = useState(null);
  const [loadingSwitchWallet, setLoadingSwitchWallet] = useState(false);

  const walletScrollRef = useRef(null);
  const { t } = useTranslation();

  const handleScroll = () => {
    const el = walletScrollRef.current;
    if (!el) return;

    setShowWalletLeft(el.scrollLeft > 0);
    setShowWalletRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 5);
  };

  useEffect(() => {
    scrollToWallet((wallets || []).map((it) => it._id).indexOf(user.wallet_id));

    const el = walletScrollRef.current;
    if (!el) return;
    el.removeEventListener("scroll", handleScroll);
    el.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => el.removeEventListener("scroll", handleScroll);
  }, [wallets, user.wallet_id]);

  const onWalletCreated = async () => {
    getProfile();
  };

  const walletClicked = async (id) => {
    if (user.wallet_id !== id) {
      setSwitchWalletContextId(id);
      setShowSwitchWallet(true);
    }
  };

  const selectUserWallet = async (id) => {
    setLoadingSwitchWallet(true);
    try {
      const path = pathObj.changeUserWallet;
      var res = await apiPost(path, { id });
      setShowSwitchWallet(false);
      storeTokens(res.data.results.token, res.data.results.refresh_token);
    } catch (error) {}
    setLoadingSwitchWallet(false);
  };

  const scrollToWallet = async (i) => {
    if (!walletScrollRef.current) return;
    const container = walletScrollRef.current;
    const item = container.children[i];
    if (!item) return;
  
    container.scrollTo({
      left: item.clientWidth * (i-1),
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="relative">
        {!wallets && (
          <div className="flex w-full justify-center">
            <FontAwesomeIcon icon={faCircleNotch} className="text-xl animate-spin h-[15rem]" />
          </div>
        )}
        {wallets && (
          <div ref={walletScrollRef} className="rounded-2xl relative flex gap-2 overflow-x-auto no-scrollbar w-full snap-x snap-mandatory">
            {(wallets || []).map((it, idx) => (
              <div key={idx} class={`snap-center shrink-0 ${sideBar ? "w-full" : "w-[25rem]"}`}>
                <div
                  className="bg-card mx-1 text-white h-full p-[1rem] cursor-pointer"
                  onClick={() => {
                    walletClicked(it._id);
                  }}
                >
                  <div className="flex w-full justify-between items-center">
                    <img src="images/whitelogo.svg" className="h-[1.5rem]" alt="LOGO" />
                    <span className="font-medium">{it.wallet_number}</span>
                  </div>
                  <div className="font-medium mt-6 ms-1">{t("BALANCE")}</div>
                  <div className="font-bold text-2xl ms-1">
                    {it.wallet_currency} {it.wallet_amount}
                  </div>
                  <div className="flex justify-between items-center mt-6 ms-1">
                    <div className="font-medium">{it.wallet_description}</div>
                    {user.wallet_id === it._id && (
                      <Button className="flex gap-2 bg-card px-2 py-1">
                        <FontAwesomeIcon icon={faCheckCircle} className="card-icon" />
                        {t("SELECTED")}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            ))}
            <AddWallet onCreate={onWalletCreated} sideBar={false} />
          </div>
        )}
        <FontAwesomeIcon
          icon={faChevronCircleRight}
          onClick={() => {
            walletScrollRef.current.scrollBy({ left: sideBar ? 100 : 500, behavior: "smooth" });
          }}
          className={`cursor-pointer absolute right-[-0.5rem] -translate-y-1/2 card-icon top-1/2 ${showWalletRight ? "block" : "hidden"}`}
          size={"2xl"}
        />
        <FontAwesomeIcon
          icon={faChevronCircleLeft}
          onClick={() => {
            walletScrollRef.current.scrollBy({ left: sideBar ? -100 : -500, behavior: "smooth" });
          }}
          className={`cursor-pointer absolute left-[-0.5rem] -translate-y-1/2 card-icon top-1/2 ${showWalletLeft ? "block" : "hidden"}`}
          size={"2xl"}
        />
      </div>
      {showSwitchWallet && (
        <BottomSheet
          open={showSwitchWallet}
          onClose={() => {
            setShowSwitchWallet(false);
          }}
          title={t("SWITCH_WALLET")}
        >
          <div className="flex w-full justify-center">
            <span className="font-medium text-lg my-5">{t("CONFIRM_SWITCHING_WALLET")}</span>
          </div>
          <div className="flex items-center justify-center mt-3 w-full">
            {loadingSwitchWallet ? (
              <div className="btn btn_theme flex items-center justify-center p-3">
                <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
              </div>
            ) : (
              <Button
                className="bg-primary py-3 px-10 rounded-lg"
                onClick={() => {
                  selectUserWallet(switchWalletContextId);
                }}
              >
                <span className="text-base font-medium text-white">{t("CONFIRM")}</span>
              </Button>
            )}
          </div>
        </BottomSheet>
      )}
    </>
  );
}

export default ScrollableWalletsDesktop;
